import React from "react";
import PropTypes from "prop-types";
import Checkbox from "../components/Checkbox";
import "./MultipleChoice.scss";

const MultipleChoice = ({
  question,
  fieldName,
  value,
  error,
  setFieldValue,
  setFieldTouched,
}) => {
  const handleChange = e => {
    const optionValue = e.target.value;
    const currentValues = value || [];

    let newValues;
    if (e.target.checked) {
      newValues = [...currentValues, optionValue];
    } else {
      newValues = currentValues.filter(v => v !== optionValue);
    }

    setFieldValue(fieldName, newValues);
    setFieldTouched(fieldName, true);
  };

  const isChecked = option => {
    return value && Array.isArray(value) && value.includes(option);
  };

  return (
    <div className="multiple-choice">
      <div className="multiple-choice__header">
        {question.question && (
          <h2 className="multiple-choice__title">
            {question.question}
            {question.required && (
              <span className="multiple-choice__required">*</span>
            )}
          </h2>
        )}

        <p className="multiple-choice__subtitle">{question.helper_text}</p>
      </div>

      <div className="multiple-choice__options">
        {question.options &&
          question.options.map((option, index) => (
            <Checkbox
              key={`${fieldName}-${index}`}
              id={`${fieldName}-${index}`}
              name={fieldName}
              value={option}
              label={option}
              checked={isChecked(option)}
              onChange={handleChange}
            />
          ))}
      </div>

      {error && <div className="multiple-choice__error">{error}</div>}
    </div>
  );
};

MultipleChoice.propTypes = {
  question: PropTypes.shape({
    question: PropTypes.string,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.array,
  error: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};

MultipleChoice.defaultProps = {
  value: [],
  error: null,
};

export default MultipleChoice;
